import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        deviceStateList: sessionStorage.getItem('deviceStateList'), // 返回状态树
        userId: sessionStorage.getItem('userId'), // 用户id
        userRights: sessionStorage.getItem('userRights'), // 用户角色
        volumeState: sessionStorage.getItem('volumeState'), // 用户角色
        addressList: [], // 用户角色
    },
    actions: {
        
    },
    mutations: {
    }
})